import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagePetitionComponent } from './manage-petition/manage-petition.component';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ManagePetitionerRoutingModule } from './manage-petitions-routing.module';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import { ManagePetitionBeneComponent } from './manage-petition-bene/manage-petition-bene.component';
import { MatDividerModule } from '@angular/material/divider';
import {DropdownModule} from 'primeng/dropdown';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {ButtonModule} from 'primeng/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TableModule} from 'primeng/table';
import {PaginatorModule} from 'primeng/paginator';
import { MultiSelectModule } from 'primeng/multiselect';
import {TooltipModule} from 'primeng/tooltip';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    ManagePetitionComponent,
    ManagePetitionBeneComponent,

  ],
  imports: [
    MatInputModule,
    MatSelectModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatTableModule,
    MatIconModule,
    MatSortModule,
    CommonModule,
    MatPaginatorModule,
    ManagePetitionerRoutingModule,
    MatDividerModule,
    DropdownModule,
    OverlayPanelModule,
    ButtonModule,
    MatCheckboxModule,
    TableModule,
    PaginatorModule,
    MultiSelectModule,
    TooltipModule,
    MatMenuModule
  ],
  exports:[
    ManagePetitionBeneComponent
  ]
})

export class ManagePetitionsModule { }
